
import { useState } from "react";
import { useParams } from "react-router-dom";
import { Box, Grid, MenuItem, TextField, Typography } from "@mui/material"
import { NumberFormatCustom } from "../../components";
import { BotonesAndCargando } from "../../components/botones";
import { mediosPago } from "../../../data";
import { useImagenStore, useModalStore } from "../../../stores";
import { AvatarScreen } from "../../ui";
import { crearAbonoOps } from "../../../services";
import { useQueryClient } from "@tanstack/react-query";
import { useOPXID } from "../../../hooks/cache";

import Swal from "sweetalert2";
import { separadorMillares } from "../../../hooks";




export const FormularioCrearAbono = () => {

    const { id } = useParams();
    const queryClient = useQueryClient();
    const { modalFormToggle } = useModalStore();
    const { imagen, valorImagen } = useImagenStore();
    const [cargando, setCargando] = useState(false);
    const { data:op } = useOPXID(id);
    const [ formAbono, setFormAbono ] = useState({ abono: "", medio: "", observacion: "" });
    const { abono, medio, observacion } = formAbono;
    const millares = NumberFormatCustom;

    
    const handleInputChange = ({ target }) => {
        setFormAbono({
            ...formAbono,
            [target.name]: target.value
        });
    }


    const handleCrearAbono = async(e) => {
        e.preventDefault();

        const campos = [abono, medio, observacion];
        if(campos.some(campo => !campo.trim())) {
            return Swal.fire('Error', 'Debes llenar todos los campos del formulario', 'error');
        }

        const { isConfirmed } = await Swal.fire({
            title: 'Crear Abono',
            text: `¿Está seguro de crear este abono?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Sí, crear',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            reverseButtons: true,
        });

        if(!isConfirmed) return;

        setCargando(true);
        const resp = await crearAbonoOps({ ...formAbono, img:imagen, op:id });
        setCargando(false);
        if(resp) { 
            queryClient.invalidateQueries({ queryKey: ['op-id'] });
            queryClient.invalidateQueries({ queryKey: ['abonosxop'] });
            modalFormToggle(false);
            valorImagen(null)
        }
    }


    return (
        <Box>
            <form  onSubmit={ handleCrearAbono } >
                <Grid container spacing={2}>
                    <AvatarScreen carpeta="abonosOp" />

                    <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center' }}>
                        <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                            {Number(abono) <= op.deudaAdmin ? 'Saldo restante' : 'Devueltas'}
                        </Typography>

                        <Typography sx={{ fontWeight:700, fontSize:24 }}>
                            {Number(abono) <= op.deudaAdmin
                            ? `$${separadorMillares(op.deudaAdmin - Number(abono || 0))}`
                            : `$${separadorMillares(Number(abono) - op.deudaAdmin)}`}
                        </Typography>
                    </Box>

                    <Grid item xs={ 12 }>
                        <TextField required
                            label="Abono"
                            fullWidth
                            placeholder='Abono'
                            name="abono"
                            value={ abono }
                            onChange={ handleInputChange }
                            InputProps={{ inputComponent: millares }}
                            size="small"
                        >
                        </TextField>
                    </Grid>

                    <Grid item xs={ 12 }>
                        <TextField required
                            select
                            label="Medio de Pago"
                            fullWidth
                            name="medio"
                            value={ medio }
                            onChange={ handleInputChange }  
                            size="small"
                        >    
                            <MenuItem value=''>
                                Seleccione Medio de Pago
                            </MenuItem>
                            {mediosPago.map( item => (
                                <MenuItem value={item} key={item}>        
                                    {item}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>

                    <Grid item xs={ 12 }>
                        <TextField
                            label="Observacion"
                            fullWidth
                            placeholder="Observacion"
                            multiline
                            name="observacion"
                            value={ observacion }
                            onChange={ handleInputChange } 
                            size="small"
                        />
                    </Grid>
                </Grid>

                <Grid container sx={{mb:2, mt:3, display:'flex', justifyContent:'center' }}>
                    <Grid item xs={12} sm={6} md={5}>
                        <BotonesAndCargando
                            cargando={cargando}
                            titulo='Crear Abono'
                            titulo2="Loading..."
                            icon1="save"
                            icon2="save"
                            esSubmit
                        />
                    </Grid>
                </Grid>

            </form>
        </Box>
    )
}